const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/u;

export const validateEmail = (value) => {
  return EMAIL_REGEX.test(value);
};
